import { render, staticRenderFns } from "./ConfigurationView.vue?vue&type=template&id=81c4b862&scoped=true"
import script from "./ConfigurationView.vue?vue&type=script&lang=js"
export * from "./ConfigurationView.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationView.vue?vue&type=style&index=0&id=81c4b862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c4b862",
  null
  
)

export default component.exports